import { createContext } from 'react';
import noop from 'lodash/noop';

import api from '../api';
import { Hotel } from '../types';
import { Context, QueryContext } from '../../../types';
import { HotelQueryType } from '../helpers';

export interface HotelContextType extends Context<Hotel> {
    query: QueryContext<HotelQueryType, Hotel>;
}

const hotelContext = createContext<HotelContextType>({
    get: api.get,
    getById: api.getById,
    // getSchema: api.getSchema,
    schema: {},
    post: api.post,
    put: api.put,
    data: [],
    setData: noop,
    selected: null,
    setSelected: noop,
    remove: api.remove,
    error: null,
    query: api.query
});
export default hotelContext;
